import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
const { FiCheckCircle } = FiIcons;

export default function ThankYou() {
  const [showConfetti, setShowConfetti] = useState(true);

  // Automatically scroll to top and hide confetti after a few seconds
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const timer = setTimeout(() => setShowConfetti(false), 4000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex items-center justify-center min-h-[80vh] bg-gray-50 px-4 overflow-hidden relative">
      {/* Subtle Sparkle/Confetti Effect */}
      {showConfetti && (
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          {[...Array(25)].map((_, i) => (
            <div
              key={i}
              className="sparkle"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 2}s`,
                backgroundColor: ['#008080', '#00A5A5', '#33CCCC'][Math.floor(Math.random() * 3)],
              }}
            />
          ))}
        </div>
      )}

      <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 text-center w-full max-w-3xl relative animate-fadeIn z-10">
        {/* Confirmation Icon */}
        <div className="mb-6">
          <div
            className="mx-auto w-20 h-20 rounded-full flex items-center justify-center shadow-inner"
            style={{ background: '#E5F9F9' }}
          >
            <FiCheckCircle className="text-[#008080]" size={44} />
          </div>
        </div>

        {/* Thank You Heading */}
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
          Thank you for your submission!
        </h1>

        {/* Description */}
        <p className="text-gray-600 text-lg max-w-2xl mx-auto mb-8">
          Your website requirements have been successfully sent to our design team.
          We will review your information and get back to you as soon as possible.
        </p>

        {/* Subtle animated confirmation bar */}
        <div className="relative mx-auto mb-10" style={{ width: 180, height: 6, background: '#E0F5F5', borderRadius: 999 }}>
          <div
            className="absolute left-0 top-0 h-full rounded-full"
            style={{
              width: '100%',
              background: 'linear-gradient(90deg, #00A5A5, #008080)',
              animation: 'pulseBar 1.4s ease-in-out 2'
            }}
          />
        </div>

        {/* Buttons */}
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/step/1"
            className="inline-flex items-center justify-center px-6 py-3 rounded-lg border-2 border-[#FF5841] text-[#FF5841] bg-white hover:bg-[#FFEEEC] transition-colors duration-200 font-medium"
          >
            Back to Form
          </Link>

          <a
            href="https://www.primehost.co.za/"
            className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-[#FF5841] text-white hover:bg-[#E5503A] transition-colors duration-200 font-medium"
          >
            Go to Home
          </a>
        </div>
      </div>

      {/* Styles */}
      <style>{`
        @keyframes pulseBar {
          0% { transform: scaleX(0); transform-origin: left; opacity: 0.6; }
          50% { transform: scaleX(1); transform-origin: left; opacity: 1; }
          100% { transform: scaleX(1); opacity: 1; }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes sparkle {
          0% { transform: translateY(0) scale(0.8); opacity: 1; }
          100% { transform: translateY(60px) scale(1.2); opacity: 0; }
        }
        .animate-fadeIn {
          animation: fadeIn 0.8s ease-out forwards;
        }
        .sparkle {
          position: absolute;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          opacity: 0.8;
          animation: sparkle 2.5s linear infinite;
        }
      `}</style>
    </div>
  );
}